import React, { useRef, useState } from "react";
import { AdSettingClassified } from "../../../../types/main-types/mainTypes";
import { deleteStandardClassified } from "../../../../services/main-service/mainService";
import { toastError, toastSuccess } from "../../../../utils/toast";
import { useNavigate } from "react-router-dom";

interface AdBoostPopupProps {
  adDetails: AdSettingClassified;
}

function AdDeletePopup({ adDetails }: AdBoostPopupProps) {
  let [deleteStatus, setDeleteStatus] = useState<string>("");
  const closeButtonRef = useRef<HTMLButtonElement | null>(null);
  const navigate = useNavigate();

  async function handleDelete() {
    let payload = { id: adDetails.id };
    try {
      const deleteAdData = await deleteStandardClassified(payload);
      toastSuccess("Item deleted successfully !");
      closeButtonRef.current?.click();
      navigate(0);
    } catch (error: any) {
      toastError(error.response.data.message);
      console.log("error while ad delete  : ", error.response.data.message);
    }
  }

  return (
    <>
      <div
        className="modal fade"
        id={`staticBackdrop_delete_${adDetails.id}`}
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex={-1}
        aria-labelledby={`staticBackdropLabel_delete_${adDetails.id}`}
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1
                className="modal-title fs-5"
                id={`staticBackdropLabel_delete_${adDetails.id}`}
              >
                You are about to delete this ad
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">Are you sure?</div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                ref={closeButtonRef}
              >
                No
              </button>
              <button
                type="button"
                className="btn btn-danger text-white"
                onClick={handleDelete}
                disabled={deleteStatus === "success"}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdDeletePopup;
